<div class="fixed-date">
    <mat-form-field>
        <mat-label>Choose Date</mat-label>
        <mat-select [disabled]="isFixedDateDisabled" [(ngModel)]="SelectedDateFilter" (selectionChange)="onDateChange($event)">
          <mat-option value="1" >Last 30 Days</mat-option>
          <mat-option value="2" >Last 3 Months</mat-option>
          <mat-option value="3" >Last 6 Months</mat-option>
        </mat-select>
      </mat-form-field>
   </div>